import { createSlice } from '@reduxjs/toolkit';

const expertsSlice = createSlice({
  name: 'experts',
  initialState: {
    experts: [],
  },
  reducers: {
    setExperts: (state, action) => {
      state.experts = action.payload;
    },
  },
});

export const { setExperts } = expertsSlice.actions;
export default expertsSlice.reducer;
